module.exports = __webpack_public_path__ + "905b2b63.svg";